export default __webpack_public_path__ + "static/media/img_22.deb439a2.jpg";